export default class StorageService {
	private static cookieRegExpPatternBegin = '(?:^|; )';
	private static cookieRegExpPatternEnd = '=([^;]*)';

	private isLocalStorageSupport: boolean = false;
	private daysTickCalculate: number = 24 * 60 * 60 * 1000;
	private expirationDefaultDays: number = 365 * 20;

	public constructor() {
		this.isLocalStorageSupport = !!window.localStorage && !!this.getBrowserSupport();
	}

	public setKey(keyName: string, value: object | string, days?: number): void {
		if (this.isLocalStorageSupport) {
			localStorage.setItem(keyName, this.formatData(value));
		} else {
			let expiration = this.getExpires(days);
			window.document.cookie = this.buildStorageItemValue(keyName, value, expiration);
		}
	}

	public getKey<T>(keyName: string): T {
		let result: T;

		if (this.isLocalStorageSupport) {
			try {
				return JSON.parse(localStorage.getItem(keyName));
			} catch (e) {
				return <T><any>localStorage.getItem(keyName);
			}
		} else {
			const regexpParse = this.cookieSplit(keyName);

			result = !!regexpParse ? JSON.parse(regexpParse[1]) : null;
		}

		return result;
	}

	public removeKey(keyName: string): void {
		if (this.isLocalStorageSupport) {
			localStorage.removeItem(keyName);
		} else {
			this.setKey(keyName, '', -1);
		}
	}

	private getBrowserSupport(): boolean {
		const windowSupport: boolean = typeof window !== 'undefined';
		const documentSupport: boolean = typeof document !== 'undefined';

		return windowSupport && documentSupport;
	}

	private getExpires(days: number): string {
		const date = new Date();
		let expires: string;

		if (!days) {
			days = this.expirationDefaultDays;
		}

		date.setTime(date.getTime() + (days * this.daysTickCalculate));
		expires = '; expires=' + date.toUTCString();

		return expires;
	}

	private buildStorageItemValue(key, value, expiration): string {
		return key + '=' + this.formatData(value) + expiration + '; path=/';
	}

	private cookieSplit(keyName: string): RegExpExecArray {
		const splitName: RegExp = new RegExp(StorageService.cookieRegExpPatternBegin + encodeURIComponent(keyName) + StorageService.cookieRegExpPatternEnd);

		return splitName.exec(window.document.cookie);
	}

	private formatData(value: object | string): string {
		let data: string;

		if (typeof value === 'object') {
			data = JSON.stringify(value);
		} else {
			data = value;
		}

		return data;
	}

}

window.storageService = new StorageService();



// WEBPACK FOOTER //
// ./Client/Scripts/storage.service.ts